<!-- Source的滚动列表 -->
<template>
    <div class="SourceScrollLoad" v-scroll="bindSourceScroll">
      <ul class="draggable_box sourceItem">
        <li
          :class="['draggable_item',{ 'pitchOnItem': PitchSource == item.id}]"
          v-for="(item, index) in sourceData"
          @click="getCheck(item, index)"
          :key="item.id"
          :data-device="JSON.stringify(item)"
          :draggable="CloneDisabled.Drag||CloneDisabled.disableButton?'false':'true'"
          :data-target="'source' + index"
          :title="item.name">
          <div class="antlineWrap">
            <img
              :src="SourceThumbnail[item.peerId]"
              :onerror="errorImg" />
               <span class="audioLevelDb" v-if="item.audioLevelDb&&item.audioLevelDb!='0'"><i class="iconfont icon-volume-up"></i> {{((0>item.audioLevelDb*1 )||(item.audioLevelDb*1==0))?' ':'+'}}{{item.audioLevelDb}}dB</span>
              <span
              class="ellipsis"
              :title="EXTName (item)" v-if="SourceType == 'ext'&&item.type=='RTP'">{{ EXTName(item) }}</span>
              <span
              class="ellipsis"
              :title="item.name" v-else>{{ item.name }}</span>
            <div class="deleteSource" v-if="SourceType == 'anywhere'">
              <i :disabled="CloneDisabled.VideoDelete||CloneDisabled.disableButton" class="iconfont  icon-icon14" @click.stop="deleteSource(item)"></i>
            </div>
            <div class="deleteSource" v-if="SourceType == 'ext'&&item.type=='RTP'" >
              <el-dropdown placement='top-start' trigger='click'  v-if="item.subNums" :class="item.subNums?'subNumShow1':'subNumShow'"  @click.stop.native="">
                    <span class="el-dropdown-link">
                    <i :disabled="CloneDisabled.VideoEdit||CloneDisabled.disableButton" v-if="item.subNums" class="iconfont icon-multi-sources" @click="getSource(item)"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                      <el-dropdown-item  v-for="(every,index) in PgmList"  :key="index" @click.native="changeSource(every,item)">{{every.name}}</el-dropdown-item>
                    </el-dropdown-menu>
              </el-dropdown>
              <div class="first" v-if="item.subNums"></div>
              <!-- <el-dropdown placement='top-start' trigger='click' v-if="item.attrNums"  :class="item.subNums?'subNumShow1':'subNumShow'"  @click.stop.native="">
                    <span class="el-dropdown-link">
                    <i :disabled="CloneDisabled.LiveSource" v-if="item.attrNums" class="iconfont icon-multi-audio" @click="getSourceAttr(item)"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                      <el-dropdown-item  v-for="(every,index) in PgmArrList"  :key="index" @click.native="changeSourceArrt(every,item)">{{every.name}}</el-dropdown-item>
                    </el-dropdown-menu>
              </el-dropdown>
              <div class="first" v-if="item.attrNums"  ></div> -->
              <div :class="item.subNums?'subNumShow1':'subNumShow'">
                <i :disabled="CloneDisabled.VideoEdit||CloneDisabled.disableButton" class="iconfont icon-bianji" @click.stop="editSource(item)"></i>
              </div>
              <div class="first" ></div>
            <div :class="item.subNums?'subNumShow1':'subNumShow'">
                <i :disabled="CloneDisabled.VideoDelete||CloneDisabled.disableButton" class="iconfont icon-icon14" @click.stop="deleteSource(item)"></i>
            </div>
            </div>
            <div class="deleteSource" v-if="SourceType == 'rtmp'||(SourceType == 'ext'&&item.type!='RTP')" >
              <div class="subNumShow">
                <i :disabled="CloneDisabled.VideoEdit||CloneDisabled.disableButton" class="iconfont icon-bianji" @click.stop="editSource(item)"></i>
              </div>
              <div class="first" ></div>
            <div class="subNumShow">
                <i :disabled="CloneDisabled.VideoDelete||CloneDisabled.disableButton" class="iconfont icon-icon14" @click.stop="deleteSource(item)"></i>
            </div>
            </div>
          </div>
        </li>
         <div class="NoData" v-if="sourceData.length == 0">
          {{$t('lang.noData')}}
          </div>
      </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SourceScrollLoad',
  props: {
    PitchSource: {
      type: String,
      default: ''
    },
    sourceData: {
      type: Array,
      default: () => []
    },
    SourceThumbnail: {
      type: Object,
      default: () => ({})
    },
    SourceType: {
      type: String
    }
  },
  watch: {
    sourceData (item) {
    }
  },
  data () {
    return {
      errorImg: `this.src="${require('@/assets/img/logo_thumbnail.png')}"`,
      // source绑定滚动事件
      bindSourceScroll: {
        onScroll: this.bindSourceScrollHandle,
        distance: 10,
        directive: '.sourceItem'
      },
      PgmList: [],
      PgmArrList: []
    }
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled
    })
  },
  created () {
  },
  mounted () {

  },
  methods: {
    // 滚动加载
    bindSourceScrollHandle () {
      this.$emit('ScrollUpdateSource', this.SourceType)
    },
    // 点击source
    getCheck (data, index) {
      this.$emit('getCheck', {
        ...data,
        index
      }, this.SourceType)
    },
    // 删除source
    deleteSource (item) {
      if (this.CloneDisabled.VideoDelete || this.CloneDisabled.disableButton) return
      this.$emit('deleteSource', {
        data: item,
        type: this.SourceType
      })
    },
    // 编辑source
    editSource (item) {
      if (this.CloneDisabled.VideoEdit || this.CloneDisabled.disableButton) return
      let type
      if (item.subNums || item.url.indexOf('?p=') != -1) {
        type = 'RTPFECPush'
      } else {
        type = this.SourceType
      }
      this.$emit('editSource', {
        data: item,
        type
      })
    },
    // ext名字
    EXTName (item) {
      if (!item.displayName) {
        return ''
      }
      const displayNameArr = item.displayName && item.displayName.split(',')
      let displayName
      if (displayNameArr[1] && displayNameArr[2]) {
        displayName = `${displayNameArr[0]}(${displayNameArr[1]}/${displayNameArr[2]})`
      } else if (displayNameArr[1] && !displayNameArr[2]) {
        displayName = `${displayNameArr[0]}(${displayNameArr[1]})`
      } else if (!displayNameArr[1] && !displayNameArr[2]) {
        displayName = item.name
      }
      return displayName
    },
    // 过去source列表
    getSource (item) {
      this.$operateSubExt({
        ...this.$TVU,
        params: { mainPeerId: item.mainPeerId },
        success: (val) => {
          this.PgmList = val
        },
        error: (val) => {

        }
      })
    },
    // 更新source
    changeSource (every, item) {
      this.$operateSubExt({
        ...this.$TVU,
        params: { mainPeerId: item.mainPeerId, selectedPeerId: every.peerId },
        type: 'update',
        success: (val) => {
          this.$message({
            message: this.$t('lang.success'),
            type: 'success'
          })
          this.$emit('reGetSourceList', 'ext')
        },
        error: (val) => {

        }
      })
    },
    getSourceAttr (item) {
      this.$operateSubExtAttr({
        ...this.$TVU,
        params: { programPeerId: item.programPeerId },
        success: (val) => {
          this.PgmArrList = val
        },
        error: (val) => {

        }
      })
    },
    changeSourceArrt (every, item) {
      this.$operateSubExtAttr({
        ...this.$TVU,
        params: { programPeerId: item.programPeerId, selectedPeerId: every.peerId },
        type: 'update',
        success: (val) => {
          this.$message({
            message: this.$t('lang.success'),
            type: 'success'
          })
          this.$emit('reGetSourceList', 'ext')
        },
        error: (val) => {

        }
      })
    }

  }
}
</script>

<style scoped lang="less">
.SourceScrollLoad {
  .sourceItem {
    max-height: 180px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-top: 8px;
    position: relative;
    .draggable_item{
      .pgmList{
        width: 140px;
        position: absolute;
        top: -100px;
      }
    }
    .NoData{
      width: 100%;
      color: #dfdfdf;
      text-align: center;
    }
    .antlineWrap {
      width: 99px;
      margin: 8px 4px;
      position: relative;
      img {
        width: 100px;
        height: 63px;
        margin-top: 3px;
        object-fit: cover;
        display: block;
      }
      .ellipsis {
        display: block;
        width: 100px;
        height: 20px;
        text-align: left;
        overflow: hidden;
        line-height: 20px;
        font-size: 12px;
        color: #dfdfdf;
        max-width: 90%
      }
      .deleteSource{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100px;
        height: 63px;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        display: none;

        i{
          color: #CCCCCC;
          // margin: 20px 8px 0px;
          font-size: 14px;
        }
        .first{
          // display: inline-block;
          width: 1px;
          height: 16px;
          background: #CCCCCC;
          // position: absolute;
          // left: 33.3px;
          // top: 50%;
          // margin-top: -8px;
        }
        .second1{
          display: inline-block;
          width: 1px;
          height: 16px;
          background: #CCCCCC;
          position: absolute;
          left: 50%;
          top: 50%;
          margin-top: -8px;
        }
        .second{
          display: inline-block;
          width: 1px;
          height: 16px;
          background: #CCCCCC;
          position: absolute;
          left: 66.6px;
          top: 50%;
          margin-top: -8px;
        }
      }
      .audioLevelDb{
        position: absolute;
        right: 0;
        top: 40px;
        color: #DBDBDB;
        font-size: 10px;
      }
    }
    .antlineWrap:hover .deleteSource{
      display: flex;
      align-items: center;
      justify-content: center;
      .subNumShow{
        // width: 50% ;
        padding: 0 9px;
        // border-right:1px solid red ;
      }
      .subNumShow1{
        // width: 33.3%;
         padding: 0 5px;
      }
    }
    .pitchOnItem {
      background: rgba(57, 170, 80, 0.25);
    }
  }
}
</style>
